module.exports = __webpack_public_path__ + "static/media/checkok.e4242c67.svg";